import SettingFrame from "../../../../components/@settings/SettingFrame";
import EmailGatewaySetting from "../../../../components/@settings/email/EmailGatewaySetting"

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function EmailGatewayPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <EmailGatewaySetting
                routeType={routeType}
            />
        </SettingFrame>
    )
}